<template>
  <div class="tools-table-events d-flex align-items-center">
    <span v-if="integrationEvents.length === 1" class="fs-12">
      {{ integrationEvents[0] }}
    </span>
    <bp-events-popper
      v-if="integrationEvents.length > 1"
      :options="popperOptions"
      class="events-popper"
    >
      <div class="events-container" slot="reference">
        <span>
          {{ integrationEvents.join(",  ") }}
        </span>
      </div>

      <div class="bp-events-popper-body">
        <div v-for="(event, i) in integrationEvents" :key="i">{{ event }}</div>
      </div>
    </bp-events-popper>
  </div>
</template>

<script>
import get from "lodash/get";
import { mapState } from "vuex";

import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  components: { "bp-events-popper": Popper },
  props: {
    events: Array
  },
  data() {
    return {
      popperOptions: {
        placement: "right",
        modifiers: {
          offset: {
            offset: "0,10px"
          },
          flip: {
            enable: true
          }
        }
      }
    };
  },
  computed: {
    ...mapState("integration", ["typeEvents"]),
    integrationEvents() {
      return [...this.events].map(e => this.formatEvent(e));
    }
  },
  methods: {
    formatEvent(event) {
      return get(
        this.typeEvents.find(t => t.id === event),
        "name",
        "-"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.tools-table-events {
  .events-popper {
    width: 100%;
    @media screen and (max-width: 991px) {
      max-width: 150px;
    }
  }
  .events-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    overflow: hidden;
    span {
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .bp-events-popper-body {
    z-index: 99999999;
    padding: 4px 8px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;

    background: var(--dark-80);
    color: var(--light);
    font-size: 12px;
  }
}
</style>
